import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../views/HomePage/";
import OurPackages from "../views/OurPackages/";
import OurProductsPage from "@/views/OurProducts/";
import KonstruktPage from "@/views/KonstruktPage";
import DeKonstruktPage from "../views/DeKonstruktPage/index";
// import DeKonstruktPage from "@/views/DeKonstruktPage/";
import ContaktPage from "@/views/ContaktPage";
import LoginPage from "@/views/LoginPage";
import JoinPage from "@/views/JoinPage/";
import ForgottenPasswordPage from "@/views/ForgottenPasswordPage/";
import ResetPasswordPage from "@/views/ResetPasswordPage";
import ActivateAccount from "@/views/ActivateAccountPage";
import MyAccountPage from "@/views/MyAccount/";
import SavedKonstrukt from "../views/SavedKonstrukt";
import HistoryDekonstruktor from "../views/HistoryDekonstruktor";
// import BrandKonstructorPage from "@/views/BrandKonstructorPage/";
import BrandCreator from "@/views/BrandCreator/";
import ManagePlanPage from "@/views/ManagePlanPage";
import TopUpPage from "@/views/TopUpPage";
// import ChangePlanPage from "@/views/ChangePlan/";
import PaymentSuccessPage from "@/views/PaymentSuccessPage";
import PaymentFailurePage from "@/views/PaymentFailurePage";
import BrandCheckerPage from "../views/BrandChecker/BrandChecker";
import Setting from "../views/Setting";
import Checkout from "../views/Checkout";
import Notfound from "../views/Notfound";
// import store from '@/store/index.js';
import AboutPage from "@/views/AboutPage/";
import PrivacyTermsConditions from "@/views/PrivacyTermsConditions";
import Privacy from "@/views/Privacy";
import BrandTesterPage from "@/views/BrandTester";
// import planMixin from "@/mixins/planMixin";
import ThankYouPage from "@/views/ThankYouPage.vue";
import SuccessMessage from "@/views/JoinPage/SuccessMessage.vue";
import NoCredits from "@/views/BrandChecker/NoCredits.vue";
import NoActivePlan from "@/views/BrandCreator/NoActivePlan.vue";

Vue.use(VueRouter);

function guardRoute(to, from, next) {
  if (sessionStorage.getItem("_khonsu_user_login_status")) {
    next();
  } else {
    next("/login");
  }
}

// function requiresPlan(to, from, next)
// {
//     if(planMixin.userplan_status)
//         next();
//     else
//         next('/my-account');
// }

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
    title: "Khonsu - Home",
  },
  {
    path: "/our-packages",
    name: "OurPackages",
    component: OurPackages,
  },
  {
    path: "/products",
    name: "Products",
    component: OurProductsPage,
  },
  {
    path: "/products/create",
    name: "KonstruktDetails",
    component: KonstruktPage,
  },
  {
    path: "/products/check",
    name: "DeKonstruktDetails",
    component: DeKonstruktPage,
  },
  {
    path: "/products/dekonstrukt1",
    name: "DeKonstruktDetails",
    component: DeKonstruktPage,
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContaktPage,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/join",
    name: "Join",
    component: JoinPage,
  },
  {
    path: "/forgotten-password",
    name: "ForgottenPassword",
    component: ForgottenPasswordPage,
  },
  {
    path: "/reset-password/:resetCode",
    name: "ResetPassword",
    component: ResetPasswordPage,
  },
  {
    path: "/activate/:email/:activationCode",
    name: "ActivateAccount",
    component: ActivateAccount,
  },
  {
    path: "/my-account",
    name: "MyAccount",
    component: MyAccountPage,
    beforeEnter: guardRoute,
  },
  {
    path: "/my-saved-creations",
    name: "SavedCreations",
    component: SavedKonstrukt,
    beforeEnter: guardRoute,
  },
  {
    path: "/check-search-history",
    name: "CheckSearchHistory",
    component: HistoryDekonstruktor,
    beforeEnter: guardRoute,
  },
  {
    path: "/brand-creator/:savekonstrukt?",
    name: "BrandCreator",
    component: BrandCreator,
    beforeEnter: guardRoute,
  },
  {
    path: "/brand-checker/:historydekonstrukt?",
    name: "BrandChecker",
    component: BrandCheckerPage,
    beforeEnter: guardRoute,
  },
  {
    path: "/brand-tester",
    name: "BrandTester",
    component: BrandTesterPage,
    beforeEnter: guardRoute,
  },
  {
    path: "/my-account/manage-plan",
    component: ManagePlanPage,
    beforeEnter: guardRoute,
  },
  {
    path: "/my-account/setting",
    component: Setting,
    beforeEnter: guardRoute,
  },
  {
    path: "/my-account/manage-plan/top-up",
    component: TopUpPage,
    beforeEnter: guardRoute,
  },
  {
    path: "/payment-success/:amount?",
    component: PaymentSuccessPage,
    beforeEnter: guardRoute,
  },
  {
    path: "/payment-failure/:amount?",
    component: PaymentFailurePage,
    beforeEnter: guardRoute,
  },
  {
    path: "/checkout",
    component: Checkout,
    beforeEnter: guardRoute,
  },
  {
    path: "/about",
    name: "About",
    component: AboutPage,
  },
  {
    path: "/terms-conditions",
    name: "Terms & Conditions",
    component: PrivacyTermsConditions,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    component: Privacy,
  },
  {
    path: "/thank-you",
    name: "ThankYou",
    component: ThankYouPage,
  },
  {
    path: "/account-success",
    name: "SuccessMessage",
    component: SuccessMessage,
  },
  {
    path: "/no-credits",
    name: "NoCredits",
    component: NoCredits,
  },
  {
    path: "/no-activeplan",
    name: "NoActivePlan",
    component: NoActivePlan,
  },
  {
    path: "/404",
    component: Notfound,
  },
  {
    path: "/:catchAll(.*)",
    redirect: "404",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
